import MenuTypology from "./MenuTypology";

export default MenuTypology;
